import { createSvgIcon } from '@mui/material';

export default createSvgIcon(
  <svg
    id="create-patient"
    width="86.751"
    height="73.316"
    viewBox="0 0 86.751 73.316"
  >
    <path
      id="Caminho_60"
      data-name="Caminho 60"
      d="M77.488,13.627H44.462L36.2,3.443A9.231,9.231,0,0,0,29.059,0H9.263A9.344,9.344,0,0,0,0,9.3v54.71a9.344,9.344,0,0,0,9.263,9.3H77.488a9.343,9.343,0,0,0,9.263-9.3V22.82A9.249,9.249,0,0,0,77.488,13.627ZM3.839,64.013V9.3A5.5,5.5,0,0,1,9.263,3.839h19.8A5.407,5.407,0,0,1,33.223,5.87l6.285,7.757H19.084a9.278,9.278,0,0,0-9.3,9.193V69.478H9.263A5.5,5.5,0,0,1,3.839,64.013Zm79.074,0a5.5,5.5,0,0,1-5.424,5.465H13.627V22.82a5.435,5.435,0,0,1,5.457-5.354h58.4a5.407,5.407,0,0,1,5.424,5.354Zm0,0"
      transform="translate(0 0)"
      fill="#757e8d"
    />
    <path
      id="Caminho_61"
      data-name="Caminho 61"
      d="M201.405,161.4H193.92v-7.485A1.919,1.919,0,0,0,192,152h-7.677a1.919,1.919,0,0,0-1.919,1.919V161.4h-7.485A1.919,1.919,0,0,0,173,163.324V171a1.919,1.919,0,0,0,1.919,1.919H182.4v7.485a1.919,1.919,0,0,0,1.919,1.919H192a1.919,1.919,0,0,0,1.919-1.919V172.92h7.485A1.919,1.919,0,0,0,203.324,171v-7.677A1.919,1.919,0,0,0,201.405,161.4Zm-1.919,7.677H192A1.919,1.919,0,0,0,190.081,171v7.485h-3.839V171a1.919,1.919,0,0,0-1.919-1.919h-7.485v-3.839h7.485a1.919,1.919,0,0,0,1.919-1.919v-7.485h3.839v7.485A1.919,1.919,0,0,0,192,165.243h7.485Zm0,0"
      transform="translate(-139.797 -122.827)"
      fill="#757e8d"
    />
  </svg>,
  'CreatePatientIcon',
);
